const onStructureField = `
  ... on StructureField {
    options {
      key
      value
    }
    name
    path
    repeatable
    indexable
    type
    translatable
    crop {
      height
      width
    }
    multilineText
    complexHtmlEditor
    mapType
    dateType
    ratingType
    ratingValue
    required
    validationType
	  validationRegex
  }
  `;

const onStructureFieldSelector = `
... on StructureFieldSelector {
  name
  options {
    key value
  }
  path
  repeatable
  indexable
  translatable
  multiple
  isRadioButton
  withImages
  selOptions {
      key
      value
  }
  selImages{
    key
    text
    media{
      id
      path
      url
    }
    valueTranslatable{
      defaultLocale
      value{
        key
        text
        media{
          id
          path
          url
        }
      }
    }
  }
  required
  __typename
}
`;

const fieldsStructureGroupWithoutStructureFields = `
  name
  options {
    key
    value
  }
  path
  repeatable
  indexable
  page
  __typename
  `;

const structureFieldsQuery = `
  structureFields {
    ${onStructureFieldSelector}
    ${onStructureField}
    ... on StructureFieldGroup {
      ${fieldsStructureGroupWithoutStructureFields}
      structureFields {
        ${onStructureFieldSelector}
        ${onStructureField}
        ... on StructureFieldGroup {
          ${fieldsStructureGroupWithoutStructureFields}
          structureFields {
            ${onStructureFieldSelector}
            ${onStructureField}
            ... on StructureFieldGroup {
              ${fieldsStructureGroupWithoutStructureFields}
              structureFields {
                ${onStructureFieldSelector}
                ${onStructureField}
                ... on StructureFieldGroup {
                  ${fieldsStructureGroupWithoutStructureFields}
                }
              }
            }
          }
        }
      }
    }
  }
  `;

export default structureFieldsQuery;
